import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color"];
import React from "react";
import { colors } from "../shared/styles";
export var Icon = React.forwardRef(function (props, ref) {
  var color = props.color,
    restProps = _objectWithoutProperties(props, _excluded);
  if (props.icon) {
    var _colors$color;
    return /*#__PURE__*/React.createElement(props.icon, Object.assign({
      ref: ref,
      color: (_colors$color = colors[color]) !== null && _colors$color !== void 0 ? _colors$color : color
    }, restProps));
  }
  return null;
});